export const officialXProfileUrl = "https://x.com/ClawEase";
export const officialXHandle = "@ClawEase";
